import Vapi from "vuex-rest-api";

const posts = new Vapi({
  baseURL: "https://www.latercera.com/wp-json/wp/v2/",
  queryParams: true,
  state: {
    posts: []
  }
})
.get({
  action: "getPosts",
  property: "posts",
  path: "/posts/?tags=29150"
})
.getStore();

export default posts;
